<template>
  <div class="skeleton-container">
    <content-loader
      v-for="item in count"
      :key="item"
      :width="900"
      :speed="1"
      height="270"
      :primary-color="`#ededed`"
      :secondary-color="`#f7f7f7`">
      <rect x="0" y="0" rx="2" ry="2" width="900" height="140" />
      <rect x="0" y="0" rx="2" ry="2" width="900" height="130" />
    </content-loader>
  </div>
</template>

<script>
// Components
import { ContentLoader } from "vue-content-loader";

export default {
  name: "DashboardSkeleton",
  components: {
    ContentLoader,
  },
  props: {
    count: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/imports";
.skeleton-container {
  svg {
    margin-bottom: 16px;
    border-radius: 0.25rem;
    border: 0.5px solid var(--Gray-300);
    box-sizing: border-box;
    box-shadow: 0px 1px 5px var(--black-variant-1),
      0px 3px 1px -2px var(--black-variant-2),
      0px 2px 2px var(--black-variant-1);
  }
}
</style>
